import { Size } from '../enums';
import css from './style.module.css';

export const sizePresets: Record<Size, string> = {
  [Size.SMALL]: css.small,
  [Size.LARGE]: css.large,
};
